import React from 'react';
import { CardLabel, Select } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import css from '../../../styles.module.css';

export default function InventorySwitch({ title, showSeats, currentInventory, setCurrentInventory = () => {}, setPreviousInventory = () => {}, inventories }) {
    const { t } = useTranslation();

    const inventoriesOptions = React.useMemo(() => {
        return inventories.map(inventory => ({ text: inventory.name, value: inventory.uuid }));
    }, [inventories]);

    const handleChange = React.useCallback(
        inventory => {
            setPreviousInventory(showSeats ? currentInventory : inventory);
            setCurrentInventory(inventory);
        },
        [setCurrentInventory, currentInventory, setPreviousInventory, showSeats]
    );

    return (
        <div className={css['add-attendees-rates-selecthierarchy']}>
            <CardLabel className={css['selecthierarchy']}>{title}</CardLabel>
            <Select onChange={handleChange} options={inventoriesOptions} value={currentInventory} placeholder={t('ticket.common.action.select')} />
        </div>
    );
}
